"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.olapicResponseStreamSchema = void 0;
var _zod = require("zod");
var _OlapicResponseStreamItem = require("./OlapicResponseStreamItem");
const olapicResponseStreamSchema = exports.olapicResponseStreamSchema = _zod.z.object({
  data: _OlapicResponseStreamItem.olapicStreamItemSchema
});
